
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-core
* (C) Copyright IBM Corp. 2018, 2021
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'createDashboardTitle': 'Создать сводную панель',
	'dashboard': 'Сводная панель',
	'dashboardTemplate': 'Шаблон сводной панели',
	'createAV': 'Создать',
	'createAvEditNameLabel': '1. Присвойте представлению имя',
	'createAvSelectTemplateLabel': '2. Выберите шаблон',
	'tabLayoutLabel': 'Шаблон с вкладками',
	'infographicsLayoutLabel': 'Инфографический шаблон',
	'singlePageLayoutLabel': 'Шаблон одной страницы',
	'customLayoutLabel': 'Пользовательский шаблон',
	'freeformTemplate': 'Произвольная форма',
	'freeformTemplateDesc': 'Визуализации в схеме с произвольной формой появляются точно с тем размером и расположением в представлении, какие вы задали для них, независимо от размера экрана. В других схемах размер и положение визуализаций корректируются, так чтобы они уместились на экране.',
	'NoTemplate': 'Произвольная форма',
	'Template1': 'Пустой',
	'Template2': 'Заголовок 1 на 2',
	'Template3': '2 над 1',
	'Template4': '4 над 1',
	'Template5': 'Сноска 1 на 2',
	'Template6': '3 рядом с 1 над 1',
	'Template7': '4 рядом с 3 над 1',
	'Template8': '2 над 3 на 2',
	'Template9': '2 на 2',
	'Template10': '1 на 2 рядом с 2 на 2 над 1',
	'Template11': '3 на 1 над 1 на 2',
	'Template12': '2 над 1 рядом с 1 на 2',
	'Template13': 'Один рядом с 1 на 2 рядом с 1 на 4',
	'Template22': '1 над 2 по 2',
	'Template14': '1 рядом с 1',
	'Template15': '1 над 1 рядом с 1',
	'Template16': '1 рядом с 1 над 1',
	'Template17': '1 над 1 рядом с 1 над 1',
	'Template18': '1 над 1 рядом с 1',
	'Template19': '1 над 2 рядом с 1',
	'Template20': '1 над 2 по 1',
	'Template21': '1 над 1 над 2 по 1',
	'Template23': 'Пустой с зоной для перетаскивания',
	'Infographics1': 'Пустой',
	'Infographics2': '4 строки',
	'Infographics3': '4 строки с заголовками',
	'Infographics4': '2 на 4',
	'Infographics5': 'Большой дисплей вверху с 2 на 2',
	'Infographics6': '2 на 4 с вертикальным зазором',
	'Infographics7': '2 на 4 в шахматном порядке',
	'Infographics8': 'Теннисный корт',
	'Infographics9': '3 на 4',
	'Infographics10': '4 на 8',
	'createAvDashboardLabel': 'Макет',
	'dashboard_template_save_success': 'Ваш шаблон сводной панели сохранен.',
	'dashboard_template_prefix': 'Шаблон: "%{name}"',
	'dashboard_template_filters_removed': 'Фильтры на холсте удалены.',
	'createAvTabLabel': 'С вкладками',
	'createAvInfographicsLabel': 'Инфографика',
	'createAvSinglepageLabel': 'Одна страница',
	'createAvCustomLabel': 'Настроить',
	'loadMoreLabel': 'Загрузить еще...',
	'backLabel': 'Перейти назад',
	'addSourceLabel': 'Добавить источник',
	'pinLabel': 'Зафиксировать',
	'errorLoadingDataSetMetaData': 'Произошла ошибка при чтении метаданных',
	'errorLoadingDataSets': 'Произошла ошибка при загрузке списка наборов данных',
	'errorLoadingDataSet': 'Метаданные для набора данных "%{datasetName}" не загрузились. Обратитесь к администратору для получения более подробной информации.',
	'okButton': 'ОК',
	'createButton': 'Создать',
	'cancelButton': 'Отмена',
	'copyButton': 'Копировать',
	'selectTemplateLabel': 'Выбрать шаблон',
	'createBoardTitle': 'Создать сводную панель',
	'createBoardSubtitle': 'Выберите шаблон для своей сводной панели',
	'noSourcesSelectedLabel': 'Не выбрано никаких источников',
	'find_label': 'Найти',
	'noDashboardFound': 'Не удается получить сводную панель. Либо оно больше не существует, либо у вас недостаточно полномочий для его просмотра.',
	'errorLabel': 'Ошибка',
	'defaultName': 'Новая сводная панель',
	'noDashboardCapability': 'У вам нет возможности запустить приложение сводной панели',
	'noDashboardPermission': 'У вас нет необходимых полномочий для просмотра этой сводной панели',
	'sourceNotFound': 'Мы не можем загрузить визуализацию, так как связанный источник "%{sourceName}" недоступен',
	'cmDuplicateName': 'Элемент с таким именем уже существует. Попробуйте использовать другое имя.',
	'cmEmptySelection': 'Сводная панель удалена. Попробуйте сохранить ее как новую сводную панель.',
	'propTheme': 'Визуальная тема',
	'legacyThemeLabel': 'Прежняя версия',
	'carbonGrey10Label': 'Светлая Carbon X',
	'carbonGrey100Label': 'Темная Carbon X',
	'titleTextLabel': 'Заголовок',
	'titleSmallTextLabel': 'Маленький заголовок',
	'subtitleTextLabel': 'Подзаголовок',
	'bodyTextLabel': 'Текст',
	'bodySmallTextLabel': 'Небольшой текст',
	'captionTextLabel': 'Заголовок',
	'quoteTextLabel': 'Квота',
	'quoteSmallTextLabel': 'Малая квота',
	'responsiveTextLabel': 'Автоматическое изменение размера',
	'mediaWidgetLabel': 'Носитель',
	'webpageWidgetLabel': 'Веб-страница',
	'imageWidgetLabel': 'Изображение',
	'textWidgetLabel': 'Текстовый',
	'notebookWidgetLabel': 'Блокнот',
	'multipurposeWidgetLabel': 'Многоцелевые',
	'textPlaceHolder': 'Щелкните для изменения текста',
	'titlePlaceHolder': 'Щелкните для изменения заголовка',
	'toggleEditModeLabel': 'Переключиться на изменение',
	'togglePreviewModeLabel': 'Переключиться на предварительный просмотр',
	'editDashboardCoachMarkTitle': 'Изменить сводную панель',
	'editDashboardCoachMarkContents': 'Щелкните по значку карандаша, чтобы изменить эту сводную панель.',
	'addDataCoachMarkTitle': 'Добавить данные',
	'addDataDashboardCoachMarkContents': 'Перетащите данные из панели данных на сводную панель.',
	'pageSelectWarning': 'Выберите вкладку.',
	'screenshot_label': 'Сводная панель %{title}',
	'screenshot_label_tab': 'Вкладка %{tabName} сводной панели %{title}',
	'dataAssetPropertiesLabel': 'Свойства визуализации',
	'modelFilter': 'Фильтр',
	'invertSelectionToolTip': 'Инвертировать выбор фильтра',
	'clearFilterValueToolTip': 'Очистить значения фильтра',
	'invertFilterSelection': 'Инверсия',
	'clearTextFilterValue': 'Очистить',
	'filterConditionLabel': 'Условие фильтра',
	'applyFilter': 'Применить фильтр',
	'itemCountText': 'Выбрано %{itemCount} элементов',
	'itemExcludeCountText': 'Исключено %{itemCount} элементов',
	'moreMembers': 'Показать больше...',
	'searchHierarchyMembers': 'Использовать поиск, чтобы найти элементы...',
	'propHideEmpty': 'Скрыть пустой',
	'propColorOrder': 'Порядок цветов',
	'propElementColor': 'Цвет элемента визуализации',
	'propLineColor': 'Цвет линии',
	'propLineAndSymbolColor': 'Цвет линии и символа',
	'propColumnColor': 'Цвет столбца',
	'propBarColor': 'Цвет столбца',
	'propWordColor': 'Цвет слова',
	'propAreaColor': 'Цвет области',
	'propRadialbarColor': 'Цвет радиального столбца',
	'propColorPalettes': 'Цветовые палитры',
	'propDashboardColorPalette': 'Текущая палитра сводной панели',
	'propNewDashboardPaletteLabel': 'Создать пользовательскую палитру сводных панелей',
	'propDashboardChangePaletteLink': 'Изменить палитру сводной панели',
	'propHideLeafNode': 'Скрыть ведущие метки',
	'propOpacity': 'Непрозрачность',
	'propOpacityDescription': 'Сделать объект более или менее прозрачным. Введите значение от 0 до 100',
	'addATab': 'Добавить новую вкладку',
	'propFredIsRed': 'Насыщенность цвета',
	'areaChartCaption': 'Диаграмма с областями',
	'areaChartDataSlot_categoriesLabel': 'Метка оси',
	'areaChartDataSlot_valuesLabel': 'Значение',
	'areaChartProp_colorPaletteLabel': 'Цветовые палитры',
	'areaChartProp_lineColorLabel': 'Цвет области',
	'areaChartProp_interpolationLabel': 'Плавные линии',
	'areaChartProp_interpolationDescription': 'Линии, соединяющие точки данных, являются кривыми.',
	'areaChartProp_hideGridLinesLabel': 'Скрыть линии сетки',
	'areaChartProp_hideGridLinesDescription': 'Скрыть линии сетки',
	'areaChartProp_hideAxisTitleLabelsLabel': 'Скрыть метки заголовков осей',
	'areaChartProp_hideAxisTitleLabelsDescription': 'Скрыть заголовки осей.',
	'areaChartProp_maintainAxisScalesLabel': 'Управление масштабом оси',
	'areaChartProp_maintainAxisScalesDescription': 'Всегда показывать минимальное и максимальное значения на осях.',
	'areaChartProp_suppressZerosLabel': 'Скрыть пустой',
	'areaChartProp_suppressZerosDescription': 'Скрыть категории без связанных значений.',
	'barChartCaption': 'Горизонтальная столбчатая диаграмма',
	'barChartDataSlot_categoriesLabel': 'Метка оси',
	'barChartDataSlot_valuesLabel': 'Значение',
	'barChartProp_colorPaletteLabel': 'Цветовые палитры',
	'barChartProp_elementColorLabel': 'Цвет столбца',
	'barChartProp_hideGridLinesLabel': 'Скрыть линии сетки',
	'barChartProp_hideGridLinesDescription': 'Скрыть линии сетки',
	'barChartProp_hideAxisTitleLabelsLabel': 'Скрыть метки заголовков осей',
	'barChartProp_hideAxisTitleLabelsDescription': 'Скрыть заголовки осей.',
	'barChartProp_maintainAxisScalesLabel': 'Управление масштабом оси',
	'barChartProp_maintainAxisScalesDescription': 'Всегда показывать минимальное и максимальное значения на осях.',
	'barChartProp_suppressZerosLabel': 'Скрыть пустой',
	'barChartProp_suppressZerosDescription': 'Скрыть категории без связанных значений.',
	'columnChartCaption': 'Гистограмма',
	'columnChartDataSlot_categoriesLabel': 'Метка оси',
	'columnChartDataSlot_valuesLabel': 'Значение',
	'columnChartProp_colorPaletteLabel': 'Цветовые палитры',
	'columnChartProp_elementColorLabel': 'Цвет столбца',
	'columnChartProp_hideGridLinesLabel': 'Скрыть линии сетки',
	'columnChartProp_hideGridLinesDescription': 'Скрыть линии сетки',
	'columnChartProp_hideAxisTitleLabelsLabel': 'Скрыть метки заголовков осей',
	'columnChartProp_hideAxisTitleLabelsDescription': 'Скрыть заголовки осей.',
	'columnChartProp_maintainAxisScalesLabel': 'Управление масштабом оси',
	'columnChartProp_maintainAxisScalesDescription': 'Всегда показывать минимальное и максимальное значения на осях.',
	'columnChartProp_suppressZerosLabel': 'Скрыть пустой',
	'columnChartProp_suppressZerosDescription': 'Скрыть категории без связанных значений.',
	'bubbleChartCaption': 'Пузырьковая диаграмма',
	'bubbleChartDataSlot_xAxisLabel': 'Горизонтальная ось',
	'bubbleChartDataSlot_yAxisLabel': 'Вертикальная ось',
	'bubbleChartDataSlot_sizeLabel': 'Размер по',
	'bubbleChartDataSlot_colorLabel': 'Цвет по',
	'bubbleChartProp_colorPaletteLabel': 'Цветовые палитры',
	'bubbleChartProp_hideGridLinesLabel': 'Скрыть линии сетки',
	'bubbleChartProp_hideGridLinesDescription': 'Скрыть линии сетки',
	'bubbleChartProp_hideAxisTitleLabelsLabel': 'Скрыть метки заголовков осей',
	'bubbleChartProp_hideAxisTitleLabelsDescription': 'Скрыть заголовки осей.',
	'bubbleChartProp_maintainAxisScalesLabel': 'Управление масштабом оси',
	'bubbleChartProp_maintainAxisScalesDescription': 'Всегда показывать минимальное и максимальное значения на осях.',
	'bubbleChartProp_hideLegendLabel': 'Скрыть легенду',
	'bubbleChartProp_hideLegendDescription': 'Скрыть легенду.',
	'bubbleChartProp_legendPositionLabel': 'Положение легенды',
	'lineChartCaption': 'Линия',
	'lineChartDataSlot_categoriesLabel': 'Метка оси',
	'lineChartDataSlot_valuesLabel': 'Значение',
	'lineChartProp_colorPaletteLabel': 'Цветовые палитры',
	'lineChartProp_lineColorLabel': 'Цвет линии и символа',
	'lineChartProp_symbolShapeLabel': 'Форма символа',
	'lineChartProp_hideSymbolsLabel': 'Скрыть символы',
	'lineChartProp_hideSymbolsDescription': 'Скрыть символы',
	'lineChartProp_hideDataLinesLabel': 'Скрыть линии',
	'lineChartProp_hideDataLinesDescription': 'Скрыть линии',
	'lineChartProp_interpolationLabel': 'Плавные линии',
	'lineChartProp_interpolationDescription': 'Линии, соединяющие точки данных, являются кривыми.',
	'lineChartProp_hideGridLinesLabel': 'Скрыть линии сетки',
	'lineChartProp_hideGridLinesDescription': 'Скрыть линии сетки',
	'lineChartProp_hideAxisTitleLabelsLabel': 'Скрыть метки заголовков осей',
	'lineChartProp_hideAxisTitleLabelsDescription': 'Скрыть заголовки осей.',
	'lineChartProp_maintainAxisScalesLabel': 'Управление масштабом оси',
	'lineChartProp_maintainAxisScalesDescription': 'Всегда показывать минимальное и максимальное значения на осях.',
	'lineChartProp_suppressZerosLabel': 'Скрыть пустой',
	'lineChartProp_suppressZerosDescription': 'Скрыть категории без связанных значений.',
	'packedBubbleChart1CatCaption': 'Упакованный пузырек',
	'packedBubbleChart1CatDataSlot_categoriesLabel': 'Категории',
	'packedBubbleChart1CatDataSlot_sizeLabel': 'Размер по',
	'packedBubbleChart1CatProp_colorPaletteLabel': 'Цветовые палитры',
	'packedBubbleChart1CatProp_elementColorLabel': 'Цвет пузырька',
	'packedBubbleChart1CatProp_hideLabelLabel': 'Скрыть метку',
	'packedBubbleChart1CatProp_hideValueLabel': 'Скрыть значение',
	'packedBubbleChart1CatProp_maintainAxisScalesLabel': 'Управление масштабом оси',
	'packedBubbleChart1CatProp_maintainAxisScalesDescription': 'Всегда показывать минимальное и максимальное значения на осях.',
	'packedBubbleChart1CatProp_suppressZerosLabel': 'Скрыть пустой',
	'packedBubbleChart1CatProp_suppressZerosDescription': 'Скрыть категории без связанных значений.',
	'heatChartCaption': 'Тепло',
	'heatChartDataSlot_valuesLabel': 'Тепло по',
	'heatChartDataSlot_xAxisLabel': 'Горизонтальная ось',
	'heatChartDataSlot_yAxisLabel': 'Вертикальная ось',
	'heatChartProp_colorPaletteLabel': 'Цветовые палитры',
	'heatChartProp_heatScalePaletteLabel': 'Порядок цветов',
	'heatChartProp_hideAxisTitleLabelsLabel': 'Скрыть метки заголовков осей',
	'heatChartProp_hideAxisTitleLabelsDescription': 'Скрыть заголовки осей.',
	'heatChartProp_maintainAxisScalesLabel': 'Управление масштабом оси',
	'heatChartProp_maintainAxisScalesDescription': 'Всегда показывать минимальное и максимальное значения на осях.',
	'heatChartProp_suppressZerosLabel': 'Скрыть пустой',
	'heatChartProp_suppressZerosDescription': 'Скрыть категории без связанных значений.',
	'heatChartProp_hideLegendLabel': 'Скрыть легенду',
	'heatChartProp_hideLegendDescription': 'Скрыть легенду.',
	'heatChartProp_legendPositionLabel': 'Положение легенды',
	'pieChartCaption': 'Круговая диаграмма',
	'pieChartDataSlot_categoriesLabel': 'Категории',
	'pieChartDataSlot_valuesLabel': 'Значение',
	'pieChartProp_colorPaletteLabel': 'Цветовые палитры',
	'pieChartProp_hideRadialValueLabel': 'Скрыть значение',
	'pieChartProp_pieAsDonutLabel': 'Показать как кольцевую диаграмму',
	'pieChartProp_pieAsDonutDescription': 'Показать как кольцевую диаграмму',
	'pieChartProp_suppressZerosLabel': 'Скрыть пустой',
	'pieChartProp_suppressZerosDescription': 'Скрыть категории без связанных значений.',
	'pieChartProp_hideLegendLabel': 'Скрыть легенду',
	'pieChartProp_hideLegendDescription': 'Скрыть легенду.',
	'pieChartProp_legendPositionLabel': 'Положение легенды',
	'map1measureCaption': 'Карта',
	'map1measureDataSlot_categoriesLabel': 'Регионы',
	'map1measureDataSlot_valuesLabel': 'Тепло регионов',
	'map1measureProp_colorPaletteLabel': 'Цветовые палитры',
	'map1measureProp_heatScalePaletteLabel': 'Порядок цветов',
	'map1measureProp_maintainAxisScalesLabel': 'Управление масштабом оси',
	'map1measureProp_maintainAxisScalesDescription': 'Всегда показывать минимальное и максимальное значения на осях.',
	'map1measureProp_suppressZerosLabel': 'Скрыть пустой',
	'map1measureProp_suppressZerosDescription': 'Скрыть категории без связанных значений.',
	'map1measureProp_hideLegendLabel': 'Скрыть легенду',
	'map1measureProp_hideLegendDescription': 'Скрыть легенду.',
	'map1measureProp_legendPositionLabel': 'Положение легенды',
	'radialChartCaption': 'Радиальный',
	'radialChartDataSlot_categoriesLabel': 'Категории',
	'radialChartDataSlot_valuesLabel': 'Значение',
	'radialChartProp_colorPaletteLabel': 'Цветовые палитры',
	'radialChartProp_elementColorLabel': 'Цвет радиального столбца',
	'radialChartProp_hideRadialTitleLabel': 'Скрыть заголовок',
	'radialChartProp_hideRadialValueLabel': 'Скрыть значение',
	'radialChartProp_maintainAxisScalesLabel': 'Управление масштабом оси',
	'radialChartProp_maintainAxisScalesDescription': 'Всегда показывать минимальное и максимальное значения на осях.',
	'radialChartProp_suppressZerosLabel': 'Скрыть пустой',
	'radialChartProp_suppressZerosDescription': 'Скрыть категории без связанных значений.',
	'pointChart1catCaption': 'Точечная диаграмма',
	'pointChart1catDataSlot_valuesLabel': 'Значение',
	'pointChart1catDataSlot_categoriesLabel': 'Метка оси',
	'pointChart1catProp_colorPaletteLabel': 'Цветовые палитры',
	'pointChart1catProp_elementColorLabel': 'Цвет формы',
	'pointChart1catProp_symbolShapeLabel': 'Форма символа',
	'pointChart1catProp_symbolFillLabel': 'Заполнить форму',
	'pointChart1catProp_symbolFillDescription': 'Показать цвет заполнения для символов.',
	'pointChart1catProp_hideGridLinesLabel': 'Скрыть линии сетки',
	'pointChart1catProp_hideGridLinesDescription': 'Скрыть линии сетки',
	'pointChart1catProp_hideAxisTitleLabelsLabel': 'Скрыть метки заголовков осей',
	'pointChart1catProp_hideAxisTitleLabelsDescription': 'Скрыть заголовки осей.',
	'pointChart1catProp_maintainAxisScalesLabel': 'Управление масштабом оси',
	'pointChart1catProp_maintainAxisScalesDescription': 'Всегда показывать минимальное и максимальное значения на осях.',
	'pointChart1catProp_suppressZerosLabel': 'Скрыть пустой',
	'pointChart1catProp_suppressZerosDescription': 'Скрыть категории без связанных значений.',
	'scatterPlotChartNoCatCaption': 'Диаграмма рассеяния',
	'scatterPlotChartNoCatDataSlot_xAxisLabel': 'Горизонтальная ось',
	'scatterPlotChartNoCatDataSlot_yAxisLabel': 'Вертикальная ось',
	'scatterPlotChartNoCatProp_colorPaletteLabel': 'Цветовые палитры',
	'scatterPlotChartNoCatProp_elementColorLabel': 'Цвет элемента',
	'scatterPlotChartNoCatProp_symbolShapeLabel': 'Форма символа',
	'scatterPlotChartNoCatProp_symbolFillLabel': 'Заполнить форму',
	'scatterPlotChartNoCatProp_symbolFillDescription': 'Показать цвет заполнения для символов.',
	'scatterPlotChartNoCatProp_hideGridLinesLabel': 'Скрыть линии сетки',
	'scatterPlotChartNoCatProp_hideGridLinesDescription': 'Скрыть линии сетки',
	'scatterPlotChartNoCatProp_hideAxisTitleLabelsLabel': 'Скрыть метки заголовков осей',
	'scatterPlotChartNoCatProp_hideAxisTitleLabelsDescription': 'Скрыть заголовки осей.',
	'radialBarChartCaption': 'Радиальный столбец',
	'radialBarChartDataSlot_categoriesLabel': 'Категории',
	'radialBarChartDataSlot_valuesLabel': 'Значение',
	'radialBarChartProp_colorPaletteLabel': 'Цветовые палитры',
	'radialBarChartProp_elementColorLabel': 'Цвет радиального столбца',
	'radialBarChartProp_hideRadialTitleLabel': 'Скрыть заголовок',
	'radialBarChartProp_maintainAxisScalesLabel': 'Управление масштабом оси',
	'radialBarChartProp_maintainAxisScalesDescription': 'Всегда показывать минимальное и максимальное значения на осях.',
	'radialBarChartProp_suppressZerosLabel': 'Скрыть пустой',
	'radialBarChartProp_suppressZerosDescription': 'Скрыть категории без связанных значений.',
	'lineColumnComboChartCaption': 'Линия и столбец',
	'lineColumnComboChartDataSlot_categoryLabel': 'Метка оси',
	'lineColumnComboChartDataSlot_lineValueLabel': 'Значение линии',
	'lineColumnComboChartDataSlot_columnValueLabel': 'Значение столбца',
	'lineColumnComboChartProp_colorPaletteLabel': 'Цветовые палитры',
	'lineColumnComboChartProp_elementColorLabel': 'Цвет столбца',
	'lineColumnComboChartProp_lineColorLabel': 'Цвет линии и символа',
	'lineColumnComboChartProp_symbolShapeLabel': 'Форма символа',
	'lineColumnComboChartProp_hideSymbolsLabel': 'Скрыть символы',
	'lineColumnComboChartProp_hideSymbolsDescription': 'Скрыть символы',
	'lineColumnComboChartProp_hideDataLinesLabel': 'Скрыть линии',
	'lineColumnComboChartProp_hideDataLinesDescription': 'Скрыть линии',
	'lineColumnComboChartProp_interpolationLabel': 'Плавные линии',
	'lineColumnComboChartProp_interpolationDescription': 'Линии, соединяющие точки данных, являются кривыми.',
	'lineColumnComboChartProp_hideGridLinesLabel': 'Скрыть линии сетки',
	'lineColumnComboChartProp_hideGridLinesDescription': 'Скрыть линии сетки',
	'lineColumnComboChartProp_hideAxisTitleLabelsLabel': 'Скрыть метки заголовков осей',
	'lineColumnComboChartProp_hideAxisTitleLabelsDescription': 'Скрыть заголовки осей.',
	'lineColumnComboChartProp_maintainAxisScalesLabel': 'Управление масштабом оси',
	'lineColumnComboChartProp_maintainAxisScalesDescription': 'Всегда показывать минимальное и максимальное значения на осях.',
	'lineColumnComboChartProp_suppressZerosLabel': 'Скрыть пустой',
	'lineColumnComboChartProp_suppressZerosDescription': 'Скрыть категории без связанных значений.',
	'lineColumnComboChartProp_hideLegendLabel': 'Скрыть легенду',
	'lineColumnComboChartProp_hideLegendDescription': 'Скрыть легенду.',
	'lineColumnComboChartProp_legendPositionLabel': 'Положение легенды',
	'summaryCaption': 'Сводка',
	'areaName': 'Диаграмма с областями',
	'areaDescription': 'Диаграмма с областями',
	'areaDataSlot_colorLabel': 'Цвет по',
	'areaDataSlot_valuesLabel': 'Значение',
	'areaDataSlot_categoriesLabel': 'Метка оси',
	'bubbleName': 'Пузырьковая диаграмма',
	'bubbleDescription': 'Пузырьковая диаграмма',
	'bubbleDataSlot_yAxisLabel': 'Вертикальная ось',
	'bubbleDataSlot_xAxisLabel': 'Горизонтальная ось',
	'bubbleDataSlot_sizeLabel': 'Размер по',
	'bubbleDataSlot_colorLabel': 'Цвет по',
	'clusterBarName': 'Горизонтальная столбчатая диаграмма',
	'clusterBarDescription': 'Горизонтальная столбчатая диаграмма',
	'clusterBarDataSlot_colorLabel': 'Цвет по',
	'clusterBarDataSlot_valuesLabel': 'Значение',
	'clusterBarDataSlot_categoriesLabel': 'Метка оси',
	'clusterBarDataSlot_valuesRepeatingLabel': 'Значение',
	'clusterColumnName': 'Гистограмма',
	'clusterColumnDescription': 'Гистограмма',
	'clusterColumnDataSlot_colorLabel': 'Цвет по',
	'clusterColumnDataSlot_valuesLabel': 'Значение',
	'clusterColumnDataSlot_categoriesLabel': 'Метка оси',
	'clusterColumnDataSlot_valuesRepeatingLabel': 'Значение',
	'clusterLineName': 'Линия',
	'clusterLineDescription': 'Линия',
	'clusterLineDataSlot_colorLabel': 'Цвет по',
	'clusterLineDataSlot_valuesLabel': 'Вертикальная ось',
	'clusterLineDataSlot_categoriesLabel': 'Горизонтальная ось',
	'clusterLineDataSlot_valuesRepeatingLabel': 'Значение',
	'gridName': 'Таблица',
	'gridDescription': 'Таблица',
	'gridDataSlot_grid_colsLabel': 'Гистограмма',
	'heatName': 'Тепло',
	'heatDescription': 'Тепло',
	'heatDataSlot_yAxisLabel': 'Вертикальная ось',
	'heatDataSlot_xAxisLabel': 'Горизонтальная ось',
	'heatDataSlot_valuesLabel': 'Тепло по',
	'lineColumnComboName': 'Линия и столбец',
	'lineColumnComboDescription': 'Линия и столбец',
	'lineColumnComboDataSlot_lineValueLabel': 'Значение линии',
	'lineColumnComboDataSlot_categoryLabel': 'Метка оси',
	'lineColumnComboDataSlot_columnValueLabel': 'Значение столбца',
	'mapName': 'Прежняя карта',
	'mapDescription': 'Прежняя карта',
	'mapDataSlot_sizeLabel': 'Размер точки',
	'mapDataSlot_valuesLabel': 'Тепло регионов',
	'mapDataSlot_sizeHeatLabel': 'Тепло точки',
	'mapDataSlot_categoriesLabel': 'Регионы',
	'packedBubbleName': 'Упакованный пузырек',
	'packedBubbleDescription': 'Упакованный пузырек',
	'packedBubbleDataSlot_sizeLabel': 'Размер по',
	'packedBubbleDataSlot_colorLabel': 'Цвет по',
	'packedBubbleDataSlot_categoriesLabel': 'Категории',
	'pieName': 'Круговая диаграмма',
	'pieDescription': 'Круговая диаграмма',
	'pieDataSlot_valuesLabel': 'Значение',
	'pieDataSlot_categoriesLabel': 'Категории',
	'playerName': 'Средство воспроизведения данных',
	'playerDescription': 'Средство воспроизведения данных',
	'playerDataSlot_categoriesLabel': 'Метка оси',
	'pointName': 'Точечная диаграмма',
	'pointDescription': 'Точечная диаграмма',
	'pointDataSlot_colorLabel': 'Цвет по',
	'pointDataSlot_valuesLabel': 'Значение',
	'pointDataSlot_categoriesLabel': 'Метка оси',
	'radialName': 'Радиальный',
	'radialDescription': 'Радиальный',
	'radialDataSlot_valuesLabel': 'Значение',
	'radialDataSlot_maxSizeLabel': 'Максимальное значение',
	'radialDataSlot_categoriesLabel': 'Категории',
	'radialBarName': 'Радиальный столбец',
	'radialBarDescription': 'Радиальный столбец',
	'radialBarDataSlot_valuesLabel': 'Значение',
	'radialBarDataSlot_categoriesLabel': 'Категории',
	'scatterPlotName': 'Диаграмма рассеяния',
	'scatterPlotDescription': 'Диаграмма рассеяния',
	'scatterPlotDataSlot_yAxisLabel': 'Вертикальная ось',
	'scatterPlotDataSlot_xAxisLabel': 'Горизонтальная ось',
	'scatterPlotDataSlot_colorLabel': 'Цвет по',
	'scatterPlotDataSlot_categoriesLabel': 'Точки',
	'stackedBarName': 'Составная горизонтальная столбчатая',
	'stackedBarDescription': 'Составная горизонтальная столбчатая',
	'stackedBarDataSlot_colorLabel': 'Цвет по',
	'stackedBarDataSlot_valuesLabel': 'Значение',
	'stackedBarDataSlot_categoriesLabel': 'Метка оси',
	'stackedBarDataSlot_valuesRepeatingLabel': 'Значение',
	'stackedColumnName': 'Составная вертикальная столбчатая',
	'stackedColumnDescription': 'Составная вертикальная столбчатая',
	'stackedColumnDataSlot_colorLabel': 'Цвет по',
	'stackedColumnDataSlot_valuesLabel': 'Значение',
	'stackedColumnDataSlot_categoriesLabel': 'Метка оси',
	'stackedColumnDataSlot_valuesRepeatingLabel': 'Значение',
	'summaryChartName': 'Сводка',
	'summaryChartDescription': 'Сводка',
	'summaryChartDataSlot_valuesLabel': 'Значение',
	'treeMapName': 'Карта дерева',
	'treeMapDescription': 'Карта дерева',
	'treeMapDataSlot_colorLabel': 'Тепло по',
	'treeMapDataSlot_valuesLabel': 'Размер по',
	'treeMapDataSlot_categoriesLabel': 'Уровень один',
	'treeMapDataSlot_level3Label': 'Уровень три',
	'treeMapDataSlot_level2Label': 'Уровень два',
	'wordCloudName': 'Облако слов',
	'wordCloudDescription': 'Облако слов',
	'wordCloudDataSlot_colorLabel': 'Цвет по',
	'wordCloudDataSlot_scaleLabel': 'Размер по',
	'wordCloudDataSlot_wordLabel': 'Слова',
	'treeMap1Cat1MeasureChartCaption': 'Карта дерева',
	'treeMap1Cat1MeasureChartDataSlot_categoriesLabel': 'Уровень один',
	'treeMap1Cat1MeasureChartDataSlot_valuesLabel': 'Размер по',
	'treeMap1Cat1MeasureChartProp_colorPaletteLabel': 'Цветовые палитры',
	'treeMap1Cat2MeasureChartProp_colorPaletteLabel': 'Цветовые палитры',
	'treeMap2Cat1MeasureChartProp_colorPaletteLabel': 'Цветовые палитры',
	'treeMap2Cat2MeasureChartProp_colorPaletteLabel': 'Цветовые палитры',
	'treeMap3Cat1MeasureChartProp_colorPaletteLabel': 'Цветовые палитры',
	'treeMap3Cat2MeasureChartProp_colorPaletteLabel': 'Цветовые палитры',
	'treeMap1Cat1MeasureChartProp_maintainAxisScalesLabel': 'Управление масштабом оси',
	'treeMap1Cat1MeasureChartProp_maintainAxisScalesDescription': 'Всегда показывать минимальное и максимальное значения на осях.',
	'treeMap1Cat1MeasureChartProp_suppressZerosLabel': 'Скрыть пустой',
	'treeMap1Cat1MeasureChartProp_suppressZerosDescription': 'Скрыть категории без связанных значений.',
	'treeMap1Cat1MeasureChartProp_hideLegendLabel': 'Скрыть легенду',
	'treeMap1Cat1MeasureChartProp_hideLegendDescription': 'Скрыть легенду.',
	'treeMap1Cat1MeasureChartProp_legendPositionLabel': 'Положение легенды',
	'wordChart1Cat1MeasureCaption': 'Облако слов',
	'wordChart1Cat1MeasureDataSlot_wordLabel': 'Слова',
	'wordChart1Cat1MeasureDataSlot_scaleLabel': 'Размер по',
	'wordChart1Cat1MeasureProp_colorPaletteLabel': 'Цветовые палитры',
	'wordChart1Cat1MeasureProp_elementColorLabel': 'Цвет слова',
	'wordChart1Cat1MeasureProp_maintainAxisScalesLabel': 'Управление масштабом оси',
	'wordChart1Cat1MeasureProp_maintainAxisScalesDescription': 'Всегда показывать минимальное и максимальное значения на осях.',
	'wordChart1Cat1MeasureProp_suppressZerosLabel': 'Скрыть пустой',
	'wordChart1Cat1MeasureProp_suppressZerosDescription': 'Скрыть категории без связанных значений.',
	'missingDataSetData': 'Данные для этого набора данных недоступны. Обновите набор данных или обратитесь к своему администратору, чтобы получить доступ к источнику.',
	'hideShowSummaries': 'Скрыть или показать сводки',
	'crosstabName': 'Перекрестная таблица',
	'value_is_not_available': 'Неприменимо',
	'swapRowsAndColumns': 'Поменять местами строки и столбцы',
	'NoPinsCollected': 'Без визуализаций с булавками',
	'pinSearchOld': 'Поиск моих булавок',
	'pinDeletedToast': 'Булавка удалена',
	'pinAddedToast': 'Булавка успешно добавлена в панель Мои булавки',
	'pinRetrieveError': 'Мы не можем получить одну или несколько булавок. Повторите попытку позже.',
	'pinErrorTitle': 'Ошибка установки булавок',
	'pinRemove': 'Снять булавку',
	'deletePin': 'Удалить булавку',
	'dataset_time': 'время',
	'dataset_date': 'дата',
	'dataset_location': 'расположение',
	'dataset_number': 'число',
	'dataset_text': 'текст',
	'widgetConditionalFormatLabel': 'Переключить элементы управления условным форматом',
	'deletePinConfirmationMessage': 'Вы действительно хотите удалить эту булавку? Произвести откат этого действия нельзя.',
	'deletePinConfirm': 'Подтвердить удаление',
	'pinDeleteError': 'Мы не можем удалить одну или несколько булавок. Повторите попытку позже.',
	'metadataPickerTitle': 'Создать набор данных',
	'moreTitle': 'Дополнительно',
	'remove_slider_handle': 'Удалить хэндл',
	'missingFiltering': 'Отсутствует столбец:',
	'unSupportedPromptType': 'Сценарий приглашения в настоящее время не поддерживается.',
	'preAggregateLabel': 'Применить значения приглашений из источника данных',
	'postAggregateLabel': 'Применить значения приглашений в отчете',
	'preAggregateText': 'Для диапазона используются значения из источника данных, а не значения, отображаемые в сводной панели.',
	'tabName_general': 'Общие', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_visDetails': 'Сведения',
	'tabName_textDetails': 'Сведения о тексте', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_mediaDetails': 'Сведения о носителе', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_webDetails': 'Сведения о веб-странице', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_imageDetails': 'Сведения об изображении', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_visualization': 'Визуализация',
	'sectionName_canvas': 'Полотно',
	'sectionName_colorsAndThemes': 'Цвет и тема',
	'colorsAndThemes_legacyWarning': 'Текущая сводная панель использует тему из более раннего выпуска. Изменение темы и сохранение сводной панели навсегда удаляит доступ к более ранним палитрам тем.',
	'sectionName_details': 'Сведения',
	'sectionName_positionAndStyle': 'Положение и стиль',
	'sectionName_appearance': 'Вид', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'sectionName_advanced': 'Дополнительно',
	'sectionName_layout': 'Макет', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'sectionName_tabs': 'Вкладки',
	'sectionName_tabTitle': 'Метка',
	'sectionName_tabBackground': 'Фон',
	'addDataSourceDialogTitle': 'Добавить источник данных',
	'addDataSourceDialogButtonLabel': 'Добавить',
	'shapesDoubleChevron': 'Двойной угол',
	'widgetsPanelTitle': 'Виджеты',
	'widgetsPanelBasicsTab': 'Основные',
	'widgetsPanelImageLibraryTab': 'Изображения',
	'widgetsPanelSectionStandard': 'Стандартный',
	'widgetsPanelSectionAdvanced': 'Дополнительно',
	'widgetsPanelSectionShapes': 'Формы',
	'customWidgetsTitle': 'Пользовательские виджеты',
	'filterItemCanvasMove': 'Добавить на холст',
	'filterOverflowMenu_Global': 'Меню переполнения всех вкладок',
	'filterOverflowMenu_Tab': 'Меню переполнения данной вкладки',
	'filterOverflowMenu_Item': 'Меню переполнения фильтра',
	'filterOverflowMenu_Single': 'Меню переполнения',
	'filterItemEdit': 'Изменить значения фильтра',
	'filterDeleteAllItems': 'Удалить все фильтры',
	'filterClearAllItems': 'Очистить все фильтры',
	'filterClearSelection': 'Очистить фильтр',
	'filterPlayerMode': 'Показать программу воспроизведения',
	'filterStaticMode': 'Показать список',
	'filterInvertSelection': 'Обратить фильтр',
	'filterIconLabel_Global': 'Все вкладки',
	'filterIconLabel_Single': 'Фильтр',
	'filterIconLabel_Tab': 'Данная вкладка',
	'filterIconTooltip_Global': 'Все вкладки',
	'filterIconTooltip_Tab': 'Данная вкладка',
	'filterIconTooltip_Single': 'Фильтр',
	'filterItemDelete': 'Удалить фильтр',
	'filterValueSeparator': ',',
	'filterRange': '%{from}-%{to}',
	'filterInvertRange': 'всё, кроме: %{from}-%{to}',
	'filterExcept': 'кроме %{values}',
	'filterAll': 'Все',
	'filterBlank': '(пустой)',
	'filterDisableRangeInvert': 'Недоступно, если этот столбец находится в фильтре "Все вкладки".',
	'filterDisableHierarchyInvert': 'Недоступно, если этот столбец является фильтром иерархии.',
	'filterSelectedOfTotal': '%{selected} из %{totalMembers}',
	'filter_date_before': 'До %{to}',
	'filter_date_before_except': 'Не раньше %{to}',
	'filter_date_after': 'После %{from}',
	'filter_date_after_except': 'Не после %{from}',
	'filter_date_between': 'Между %{from}-%{to}',
	'filter_date_between_except': 'Не между %{from}-%{to}',
	'filter_drag_and_drop_all_tabs': 'Перетащите сюда данные, чтобы применить фильтр ко всем вкладкам.',
	'filter_drag_and_drop_current_tab': 'Перетащите сюда данные, чтобы применить фильтр к данной вкладке.',
	'filter_drag_and_drop_single_dock': 'Перетащите сюда данные, чтобы применить фильтр.',
	'errMsgFilterItemGenericTitle': 'Не удается загрузить значения фильтра',
	'widgetChromeRotate': 'Повернуть',
	'toolbarRegionLabel': 'Панель инструментов',
	'toolbarActionDelete': 'Удалить',
	'toolbarActionGroup': 'Группа',
	'toolbarActionUngroup': 'Разгруппировать',
	'toolbarActionOrderToFront': 'На передний план',
	'toolbarActionOrderToBack': 'На задний план',
	'toolbarActionEditTitle': 'Изменить заголовок',
	'toolbarActionWrapTitle': 'Свернуть заголовок',
	'toolbarActionPin': 'Собрать',
	'toolbarActionPinOld': 'Зафиксировать',
	'toolbarActionAlign': 'Выровнять',
	'alignWidgetLeft': 'Слева',
	'alignWidgetCenter': 'По центру',
	'alignWidgetRight': 'Справа',
	'alignWidgetTop': 'Вверху',
	'alignWidgetMiddle': 'Середина',
	'alignWidgetBottom': 'Внизу',
	'toolbarChangeVisualization': 'Изменить визуализацию',
	'multipurposeHeader': 'Выберите тип виджета',
	'multipurposePlaceholderText': 'Выберите один из виджетов, чтобы начать работу.',
	'live_label': 'Диаграмма',
	'filter_label': 'Фильтр',
	'one_named_live': 'Диаграмма %{name}',
	'one_named_live_numbered': 'Диаграмма %{name} (%{number})',
	'one_unknown_live': 'Диаграмма',
	'one_unknown_live_numbered': 'Диаграмма (%{number})',
	'few_live': 'Группа диаграмм %{count}',
	'many_live': 'Группа диаграмм %{count}',
	'one_custom': 'Пользовательский виджет',
	'one_custom_named': '%{name}',
	'one_custom_named_numbered': '%{name} (%{number})',
	'one_named_filter': 'Фильтр %{name}',
	'one_named_filter_numbered': 'Фильтр %{name} (%{number})',
	'one_unknown_filter': 'Фильтр',
	'one_unknown_filter_numbered': 'Фильтр (%{number})',
	'few_filter': 'Группа фильтров %{count}',
	'many_filter': 'Группа фильтров %{count}',
	'LIVE_bar_has_mapping': 'Столбчатая диаграмма %{values}',
	'LIVE_bar_has_mapping_numbered': 'Столбчатая диаграмма %{values} (%{number})',
	'LIVE_bar_opt_mapping': 'Столбчатая диаграмма %{categories} по %{values}',
	'LIVE_bar_opt_mapping_numbered': 'Столбчатая диаграмма %{categories} по %{values} (%{number})',
	'LIVE_bar_no_mapping': 'Пустая горизонтальная столбчатая диаграмма',
	'LIVE_bar_no_mapping_numbered': 'Пустая столбчатая диаграмма (%{number})',
	'LIVE_bar_named': 'Столбчатая диаграмма %{name}',
	'LIVE_bar_named_numbered': 'Столбчатая диаграмма %{name} (%{number})',
	'LIVE_stacked_bar_has_mapping': 'Составная столбчатая диаграмма %{values}',
	'LIVE_stacked_bar_has_mapping_numbered': 'Составная столбчатая диаграмма %{values} (%{number})',
	'LIVE_stacked_bar_opt_mapping': 'Составная столбчатая диаграмма %{categories} по %{values}',
	'LIVE_stacked_bar_opt_mapping_numbered': 'Составная столбчатая диаграмма %{categories} по %{values} (%{number})',
	'LIVE_stacked_bar_no_mapping': 'Пустая составная горизонтальная столбчатая диаграмма',
	'LIVE_stacked_bar_no_mapping_numbered': 'Пустая составная столбчатая диаграмма (%{number})',
	'LIVE_stacked_bar_named': 'Составная столбчатая диаграмма %{name}',
	'LIVE_stacked_bar_named_numbered': 'Составная столбчатая диаграмма %{name} (%{number})',
	'LIVE_bubble_has_mapping': 'Пузырьковая диаграмма %{categories} по %{x} и %{y}',
	'LIVE_bubble_has_mapping_numbered': 'Пузырьковая диаграмма %{categories} по %{x} и %{y} (%{number})',
	'LIVE_bubble_no_mapping': 'Пустая пузырьковая диаграмма',
	'LIVE_bubble_no_mapping_numbered': 'Пустая пузырьковая диаграмма (%{number})',
	'LIVE_bubble_named': 'Пузырьковая диаграмма %{name}',
	'LIVE_bubble_named_numbered': 'Пузырьковая диаграмма %{name} (%{number})',
	'LIVE_composite_has_mapping': 'Сложная диаграмма %{categories} по %{columnValue} и %{lineValue}',
	'LIVE_composite_has_mapping_numbered': 'Сложная диаграмма %{categories} по %{columnValue} и %{lineValue} (%{number})',
	'LIVE_composite_no_mapping': 'Пустая сложная диаграмма',
	'LIVE_composite_no_mapping_numbered': 'Пустая сложная диаграмма (%{number})',
	'LIVE_composite_named': 'Сложная диаграмма %{name}',
	'LIVE_composite_named_numbered': 'Сложная диаграмма %{name} (%{number})',
	'LIVE_decision_tree_has_mapping': 'Дерево решений %{values}',
	'LIVE_decision_tree_has_mapping_numbered': 'Дерево решений %{values} (%{number})',
	'LIVE_decision_tree_no_mapping': 'Пустое дерево решений',
	'LIVE_decision_tree_no_mapping_numbered': 'Пустое дерево решений (%{number})',
	'LIVE_decision_tree_named': 'Дерево решений %{name}',
	'LIVE_decision_tree_named_numbered': 'Дерево решений %{name} (%{number})',
	'LIVE_packed_bubble_has_mapping': 'Упакованная пузырьковая диаграмма %{categories}',
	'LIVE_packed_bubble_has_mapping_numbered': 'Упакованная пузырьковая диаграмма %{categories} (%{number})',
	'LIVE_packed_bubble_no_mapping': 'Пустая упакованная пузырьковая диаграмма',
	'LIVE_packed_bubble_no_mapping_numbered': 'Пустая упакованная пузырьковая диаграмма (%{number})',
	'LIVE_packed_bubble_named': 'Упакованная пузырьковая диаграмма %{name}',
	'LIVE_packed_bubble_named_numbered': 'Упакованная пузырьковая диаграмма %{name} (%{number})',
	'LIVE_pie_has_mapping': 'Круговая диаграмма %{categories} по %{values}',
	'LIVE_pie_has_mapping_numbered': 'Круговая диаграмма %{categories} по %{values} (%{number})',
	'LIVE_pie_no_mapping': 'Пустая круговая диаграмма',
	'LIVE_pie_no_mapping_numbered': 'Пустая круговая диаграмма (%{number})',
	'LIVE_pie_named': 'Круговая диаграмма %{name}',
	'LIVE_pie_named_numbered': 'Круговая диаграмма %{name} (%{number})',
	'LIVE_pie_as_donut_has_mapping': 'Тороидальная диаграмма %{categories} по %{values}',
	'LIVE_pie_as_donut_has_mapping_numbered': 'Тороидальная диаграмма %{categories} по %{values} (%{number})',
	'LIVE_pie_as_donut_no_mapping': 'Пустая кольцевая диаграмма',
	'LIVE_pie_as_donut_no_mapping_numbered': 'Пустая тороидальная диаграмма (%{number})',
	'LIVE_pie_as_donut_named': 'Тороидальная диаграмма %{name}',
	'LIVE_pie_as_donut_named_numbered': 'Тороидальная диаграмма %{name} (%{number})',
	'LIVE_line_has_mapping': 'Линейная диаграмма %{categories} по %{values}',
	'LIVE_line_has_mapping_numbered': 'Линейная диаграмма %{categories} по %{values} (%{number})',
	'LIVE_line_no_mapping': 'Пустая линейная диаграмма',
	'LIVE_line_no_mapping_numbered': 'Пустая линейная диаграмма (%{number})',
	'LIVE_line_named': 'Линейная диаграмма %{name}',
	'LIVE_line_named_numbered': 'Линейная диаграмма %{name} (%{number})',
	'LIVE_area_has_mapping': 'Диаграмма с областями %{categories} по %{values}',
	'LIVE_area_has_mapping_numbered': 'Диаграмма с областями %{categories} на %{values} (%{number})',
	'LIVE_area_no_mapping': 'Пустая диаграмма с областями',
	'LIVE_area_no_mapping_numbered': 'Пустая диаграмма с областями (%{number})',
	'LIVE_area_named': 'Диаграмма с областями %{name}',
	'LIVE_area_named_numbered': 'Диаграмма с областями %{name} (%{number})',
	'LIVE_area_as_stacked_percent_has_mapping': 'Составная диаграмма с процентными областями %{categories} на %{values}',
	'LIVE_area_as_stacked_percent_has_mapping_numbered': 'Составная диаграмма с процентными областями %{categories} на %{values} (%{number})',
	'LIVE_area_as_stacked_percent_no_mapping': 'Пустая составная диаграмма с областями в процентах',
	'LIVE_area_as_stacked_percent_no_mapping_numbered': 'Пустая составная диаграмма с областями в процентах (%{number})',
	'LIVE_area_as_stacked_percent_named': 'Составная диаграмма с областями в процентах %{name}',
	'LIVE_area_as_stacked_percent_named_numbered': 'Составная диаграмма с областями в процентах %{name} (%{number})',
	'LIVE_heatmap_has_mapping': 'Тепловая карта %{color}',
	'LIVE_heatmap_has_mapping_numbered': 'Тепловая карта %{color} (%{number})',
	'LIVE_heatmap_no_mapping': 'Пустая тепловая карта',
	'LIVE_heatmap_no_mapping_numbered': 'Пустая тепловая карта (%{number})',
	'LIVE_heatmap_named': 'Тепловая карта %{name}',
	'LIVE_heatmap_named_numbered': 'Тепловая карта %{name} (%{number})',
	'LIVE_network_opt_mapping': 'Сеть %{categories} по %{series} и %{values}',
	'LIVE_network_opt_mapping_numbered': 'Сеть %{categories} по %{series} и %{values} (%{number})',
	'LIVE_network_has_mapping': 'Сеть %{categories} по %{series}',
	'LIVE_network_has_mapping_numbered': 'Сеть %{categories} по %{series} (%{number})',
	'LIVE_network_no_mapping': 'Пустая сеть',
	'LIVE_network_no_mapping_numbered': 'Пустая сеть (%{number})',
	'LIVE_network_named': 'Сеть %{name}',
	'LIVE_network_named_numbered': 'Сеть %{name} (%{number})',
	'LIVE_radial_bar_opt_mapping': 'Радиальная столбчатая диаграмма %{categories} по %{values}',
	'LIVE_radial_bar_opt_mapping_numbered': 'Радиальная столбчатая диаграмма %{categories} по %{values} (%{number})',
	'LIVE_radial_bar_has_mapping': 'Радиальная столбчатая диаграмма %{values}',
	'LIVE_radial_bar_has_mapping_numbered': 'Радиальная столбчатая диаграмма %{values} (%{number})',
	'LIVE_radial_bar_no_mapping': 'Пустая радиальная столбчатая диаграмма',
	'LIVE_radial_bar_no_mapping_numbered': 'Пустая радиальная столбчатая диаграмма (%{number})',
	'LIVE_radial_bar_named': 'Радиальная столбчатая диаграмма %{name}',
	'LIVE_radial_bar_named_numbered': 'Радиальная столбчатая диаграмма %{name} (%{number})',
	'LIVE_spiral_has_mapping': 'Спиральная диаграмма %{values}',
	'LIVE_spiral_has_mapping_numbered': 'Спиральная диаграмма %{values} (%{number})',
	'LIVE_spiral_no_mapping': 'Пустая спиральная диаграмма',
	'LIVE_spiral_no_mapping_numbered': 'Пустая спиральная диаграмма (%{number})',
	'LIVE_spiral_named': 'Спиральная диаграмма %{name}',
	'LIVE_spiral_named_numbered': 'Спиральная диаграмма %{name} (%{number})',
	'LIVE_treemap_has_mapping': 'Карта дерева %{categories} по %{size}',
	'LIVE_treemap_has_mapping_numbered': 'Карта дерева %{categories} по %{size} (%{number})',
	'LIVE_treemap_no_mapping': 'Пустая карта дерева',
	'LIVE_treemap_no_mapping_numbered': 'Пустая карта дерева (%{number})',
	'LIVE_treemap_named': 'Карта дерева %{name}',
	'LIVE_treemap_named_numbered': 'Карта дерева %{name} (%{number})',
	'LIVE_wordcloud_has_mapping': 'Облако слов %{categories}',
	'LIVE_wordcloud_has_mapping_numbered': 'Облако слов %{categories} (%{number})',
	'LIVE_wordcloud_no_mapping': 'Пустое облако слов',
	'LIVE_wordcloud_no_mapping_numbered': 'Пустое облако слов (%{number})',
	'LIVE_wordcloud_named': 'Облако слов %{name}',
	'LIVE_wordcloud_named_numbered': 'Облако слов %{name} (%{number})',
	'LIVE_data_player_has_mapping': 'Средство воспроизведения данных %{category}',
	'LIVE_data_player_has_mapping_numbered': 'Средство воспроизведения данных %{category} (%{number})',
	'LIVE_data_player_no_mapping': 'Пустое средство воспроизведения данных',
	'LIVE_data_player_no_mapping_numbered': 'Пустое средство воспроизведения данных (%{number})',
	'LIVE_data_player_named': 'Средство воспроизведения данных %{name}',
	'LIVE_data_player_named_numbered': 'Средство воспроизведения данных %{name} (%{number})',
	'LIVE_map_has_mapping': 'Карта %{locations}',
	'LIVE_map_has_mapping_numbered': 'Карта %{locations} (%{number})',
	'LIVE_map_no_mapping': 'Пустая карта',
	'LIVE_map_no_mapping_numbered': 'Пустая карта (%{number})',
	'LIVE_map_named': 'Карта %{name}',
	'LIVE_map_named_numbered': 'Карта %{name} (%{number})',
	'LIVE_point_has_mapping': 'Точечная диаграмма %{categories} по %{values}',
	'LIVE_point_has_mapping_numbered': 'Точечная диаграмма %{categories} по %{values} (%{number})',
	'LIVE_point_no_mapping': 'Пустая точечная диаграмма',
	'LIVE_point_no_mapping_numbered': 'Пустая точечная диаграмма (%{number})',
	'LIVE_point_named': 'Точечная диаграмма %{name}',
	'LIVE_point_named_numbered': 'Точечная диаграмма %{name} (%{number})',
	'LIVE_column_has_mapping': 'Вертикальная столбчатая диаграмма %{values}',
	'LIVE_column_has_mapping_numbered': 'Вертикальная столбчатая диаграмма %{values} (%{number})',
	'LIVE_column_opt_mapping': 'Вертикальная столбчатая диаграмма %{categories} по %{values}',
	'LIVE_column_opt_mapping_numbered': 'Вертикальная столбчатая диаграмма %{categories} по %{values} (%{number})',
	'LIVE_column_no_mapping': 'Пустая вертикальная столбчатая диаграмма',
	'LIVE_column_no_mapping_numbered': 'Пустая столбчатая диаграмма (%{number})',
	'LIVE_column_named': 'Вертикальная столбчатая диаграмма %{name}',
	'LIVE_column_named_numbered': 'Вертикальная столбчатая диаграмма %{name} (%{number})',
	'LIVE_stacked_column_has_mapping': 'Составная вертикальная столбчатая диаграмма %{values}',
	'LIVE_stacked_column_has_mapping_numbered': 'Составная вертикальная столбчатая диаграмма %{values} (%{number})',
	'LIVE_stacked_column_opt_mapping': 'Составная вертикальная столбчатая диаграмма %{categories} по %{values}',
	'LIVE_stacked_column_opt_mapping_numbered': 'Составная вертикальная столбчатая диаграмма %{categories} по %{values} (%{number})',
	'LIVE_stacked_column_no_mapping': 'Пустая составная вертикальная столбчатая диаграмма',
	'LIVE_stacked_column_no_mapping_numbered': 'Пустая составная вертикальная столбчатая диаграмма (%{number})',
	'LIVE_stacked_column_named': 'Составная вертикальная столбчатая диаграмма %{name}',
	'LIVE_stacked_column_named_numbered': 'Составная вертикальная столбчатая диаграмма %{name} (%{number})',
	'LIVE_scatter_opt_mapping': 'Диаграмма рассеяния %{categories} по %{x} и %{y}',
	'LIVE_scatter_opt_mapping_numbered': 'Диаграмма рассеяния %{categories} по %{x} и %{y} (%{number})',
	'LIVE_scatter_has_mapping': 'Диаграмма рассеяния %{x} и %{y}',
	'LIVE_scatter_has_mapping_numbered': 'Диаграмма рассеяния %{x} и %{y} (%{number})',
	'LIVE_scatter_no_mapping': 'Пустая диаграмма рассеяния',
	'LIVE_scatter_no_mapping_numbered': 'Пустая диаграмма рассеяния (%{number})',
	'LIVE_scatter_named': 'Диаграмма рассеяния %{name}',
	'LIVE_scatter_named_numbered': 'Диаграмма рассеяния %{name} (%{number})',
	'LIVE_waterfall_has_mapping': 'Каскадная диаграмма %{values}',
	'LIVE_waterfall_has_mapping_numbered': 'Каскадная диаграмма %{values} (%{number})',
	'LIVE_waterfall_no_mapping': 'Пустая каскадная диаграмма',
	'LIVE_waterfall_no_mapping_numbered': 'Пустая каскадная диаграмма (%{number})',
	'LIVE_waterfall_named': 'Каскадная диаграмма %{name}',
	'LIVE_waterfall_named_numbered': 'Каскадная диаграмма %{name} (%{number})',
	'LIVE_empty_visualization_hint_title': 'Построить свою собственную визуализацию',
	'LIVE_empty_visualization_hint_description': 'Перетащите столбцы в это место или на расположенные слева слоты.',
	'LIVE_slots_required_field_description': '%{asterisk} Указывает обязательное поле',
	'LIVE_slots_drag_and_drop_description': 'Перетащите данные на находящиеся выше слоты, чтобы построить визуализацию и применить к ней фильтр.',
	'requiredField': 'Требуемое поле',
	'fullScreenEnter': 'Войти в полный экран',
	'fullScreenClose': 'Закрыть полный экран',
	'noExtraText_multipurpose': 'Многоцелевой заполнитель',
	'noExtraText_multipurpose_numbered': 'Многоцелевой заполнитель (%{number})',
	'one_placeholder_vis': 'Заполнитель визуализации',
	'one_placeholder_vis_numbered': 'Заполнитель визуализации (%{number})',
	'one_placeholder_text': 'Заполнитель текста',
	'one_placeholder_text_numbered': 'Заполнитель текста (%{number})',
	'few_placeholder_text': 'Группа заполнителей текста %{count}',
	'many_placeholder_text': 'Группа заполнителей текста %{count}',
	'filter_includesAll': 'Включить все',
	'timeline_filter_moved_to': 'Фильтр временного ряда %{id} перемещен в %{time}',
	'timelineSettingsButton': 'Опции воспроизведения',
	'autoPlay': 'Воспроизвести все сцены',
	'loop': 'Цикл',
	'noSceneTransitionLabel': 'Нет',
	'sceneTransitionPropertyLabel': 'Переход сцены',
	'animatedPathSceneTransitionLabel': 'Анимированный путь',
	'sweepSceneTransitionLabel': 'Протянуть',
	'propAniAnimation': 'Анимация',
	'propAniTypeEntrance': 'Анимация входа',
	'propAniDirectionIn': 'Направление входа',
	'propAniTypeExit': 'Анимация выхода',
	'propAniDirectionOut': 'Направление выхода',
	'propAniDirection': 'Направление',
	'timelineAnimationProperties': 'Открыть свойства анимации',
	'editStoryCoachMarkTitle': 'Изменить историю',
	'editStoryCoachMarkContents': 'Щелкните по значку карандаша, чтобы изменить эту историю.',
	'addDataStoryCoachMarkContents': 'Перетащите данные из панели данных на историю.',
	'expandSceneCoachmarkTitle': 'Открыть временную шкалу',
	'expandSceneCoachmarkContents': 'Анимировать сцену, скорректировав видимость объекта на основе времени и продолжительности.',
	'overviewCoachmarkTitle': 'Обзорные сцены',
	'overviewCoachmarkContents': 'Используйте обзорные сцены в начале и конце истории с целью показать комплексное представление всех сцен. С обзорной сцены щелкните по сцене и перетащите, чтобы поменять ее на другую сцену. Обзорные сцены можно показать или скрыть в свойствах истории.',
	'animatedPathCoachmarkTitle': 'Анимированный путь',
	'animatedPathCoachmarkContents': 'Позволяет анимировать объект при переходе от одной сцене к другой, дублировать сцену с объектом. Затем переместите или поверните дублированный объект на новой сцене либо измените его размер.',
	'tabName_animation': 'Анимация',
	'textWidgetIconPlaceholderText': 'Щелкните для добавления текста',
	'buildVisHeader': 'Создать визуализацию',
	'visIconPlaceholderText': 'Перетащите поля, чтобы построить визуализацию',
	'launchNewExplore': 'Новое исследование',
	'addTo': 'Добавить в',
	'addToExisting': 'Добавить к существующим...',
	'exploreData': 'Исследовать',
	'explore_remove_widget_styles': 'Пользовательские свойства визуализации, такие как цветовые настройки, не будут сохранены в исследовании.',
	'editNotebook': 'Изменить виджет',
	'thumbnails_error_fetching': 'Ошибка при получении миниизображений',
	'copy': '%{count} активов скопировано',
	'specConvertErr': 'При вставке или преобразовании спецификации сводной панели произошла ошибка',
	'specCopyErr': 'Ошибка при копировании спецификации сводной панели',
	'pasteNotSupportedErr': 'Вставка из %{name} не поддерживается.',
	'reportParam': 'отчет',
	'filterWidgetCopyWarn': 'Визуализация фильтра не скопирована, потому что фильтры в данное время не поддерживаются.',
	'upgradingDashboard': 'Обновление "%{name}" для %{version}...',
	'upgradeComplete': 'Обновление завершено',
	'individualTabProperties': 'Свойства отдельных вкладок',
	'propMasterTabStylesLabel': 'Стиль главной вкладки',
	'propTabPosition': 'Положение вкладки',
	'propTabTitle': 'Заголовок',
	'propTabBackgroundColor': 'Цвет заливки',
	'propTabTextColor': 'Цвет заголовка',
	'propTabSelectedBarColor': 'Выбранный цвет столбца',
	'propTabRestoreDefaults': 'Восстановить значения по умолчанию',
	'propIndividualTabStylesLabel': 'Стили отдельных вкладок',
	'propIndividualTabStylesAriaLabel': 'Открыть свойства стиля отдельных вкладок',
	'propTabIconPosition': 'Положение значка',
	'propLeftTitle': 'Слева от заголовка',
	'propRightTitle': 'Справа от заголовка',
	'propTopTitle': 'Выше заголовка',
	'propBottomTitle': 'Ниже заголовка',
	'propTabIconLabel': 'Визуальный',
	'propTabIcon': 'Значок',
	'propTabIconColor': 'Цвет значка',
	'no_icon': 'Пустой',
	'announcement': 'Объявление',
	'api': 'API',
	'archive': 'Архив',
	'asset': 'Актив',
	'attachment': 'Вложение',
	'audio': 'Аудио',
	'bee': 'Пчела',
	'blog': 'Блог',
	'bookmark': 'Закладка',
	'calendar': 'Календарь',
	'camera': 'Камера',
	'capability': 'Возможность',
	'catalog': 'Каталог',
	'chat_message': 'Сообщение чата',
	'checkout_cart': 'Корзина покупок',
	'client': 'Клиент',
	'clock': 'Часы',
	'cloud': 'Облако',
	'code': 'Код',
	'data_quality': 'Качество данных',
	'folder': 'Папки',
	'forum': 'Форум',
	'glasses': 'Очки',
	'group': 'Группа',
	'hat': 'Шляпа',
	'headphone': 'Наушники',
	'hills': 'Холмы',
	'home': 'Домой',
	'idea': 'Идея',
	'image': 'Изображение',
	'inventory': 'Запасы',
	'like': 'Подобно',
	'link': 'Связать',
	'location': 'Расположение',
	'manage': 'Управление',
	'pen': 'Перо',
	'mobile_phone': 'Мобильный телефон',
	'music': 'Музыка',
	'notifications': 'Уведомления',
	'paint': 'Рисунок',
	'payment': 'Платеж',
	'password_key': 'Ключ пароля',
	'people': 'Сотрудники',
	'person': 'Личность',
	'phone': 'Телефон',
	'pin': 'Зафиксировать',
	'print': 'Печать',
	'recording': 'Запись',
	'repository': 'Репозиторий',
	'role': 'Роль',
	'search': 'Поиск',
	'properties': 'Свойства',
	'speaker': 'Динамик',
	'star': 'Звезда',
	'tag': 'Тег',
	'thumbs_up': 'Большие пальцы вверх',
	'thumbs_down': 'Большие пальцы вниз',
	'tools': 'Инструменты',
	'traffic': 'Трафик',
	'trash': 'Мусор',
	'twitter': 'Twitter',
	'unknown': 'Неизвестно',
	'user': 'Пользователь',
	'venn_diagram': 'Диаграмма Венна',
	'video': 'Видео',
	'view': 'Показать',
	'warning': 'Предупреждение',
	'watch': 'Наблюдение',
	'watson': 'Watson',
	'wikis': 'Википедии',
	'workspace': 'Рабочее пространство',
	'world': 'Мировой',
	'OnLoadFilterModifierDatasourceMismatch': 'Фильтры не будут применены к целевому объекту, потому что сводные панели используют другие источники.',
	'OnLoadFilterModifierColumnMismatch': 'Один или несколько фильтров не были применены, поскольку не удалось найти соответствующие столбцы.',
	'eventGroupButtonLabel': 'Просмотреть соединения виджета',
	'dockToolbar': 'Закрепить панель инструментов',
	'undockToolbar': 'Открепить панель инструментов',
	'propShowTitle': 'Показать заголовок'
});
